import React, { useEffect, useState } from "react";

import SubTitle from "./SubTitle";

const parseTime = (timeStr) => {
  const timeParts = timeStr?.match(/(\d+(\.\d+)?)\s*(h|m|s)/g);
  let totalSeconds = 0;

  if (timeParts) {
    timeParts.forEach((part) => {
      const [value, unit] = part.split(/\s*(?=h|m|s)/);
      const timeValue = parseFloat(value);

      if (unit === "h") totalSeconds += timeValue * 3600;
      else if (unit === "m") totalSeconds += timeValue * 60;
      else if (unit === "s") totalSeconds += timeValue;
    });
  }

  return totalSeconds;
};

const formatTime = (seconds) => {
  if (seconds === 0) return "0 s";

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = (seconds % 60).toFixed(2);

  if (hours === 0 && minutes === 0 && secs === "0.00") return "0 s";

  const hoursDisplay = hours > 0 ? `${hours}h ` : "";
  const minutesDisplay = minutes > 0 ? `${minutes}m ` : "";
  const secondsDisplay = secs > 0 ? `${parseFloat(secs)}s` : "";

  return `${hoursDisplay}${minutesDisplay}${secondsDisplay}`.trim();
};

const TaskStatus = (props) => {
  const { pipelinesWithLogs } = props;
  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    if (pipelinesWithLogs && pipelinesWithLogs.length > 0) {
      const formattedData = pipelinesWithLogs.map((pipeline) => {
        const logEntries = pipeline.pipeline_logs.reduce(
          (acc, log) => {
            switch (log.agent) {
              case "validation":
                acc.dataValidation = formatTime(parseTime(log.total_duration));
                acc.dataValidationSeconds = parseTime(log.total_duration);
                break;
              case "mapping":
                acc.mappedIn = formatTime(parseTime(log.total_duration));
                acc.mappedInSeconds = parseTime(log.total_duration);
                break;
              case "transformation":
                acc.transformation = formatTime(parseTime(log.total_duration));
                acc.transformationSeconds = parseTime(log.total_duration);
                break;
              case "push":
                acc.dataLoadedIn = formatTime(parseTime(log.total_duration));
                acc.dataLoadedInSeconds = parseTime(log.total_duration);
                break;
              default:
                break;
            }
            return acc;
          },
          { taskName: pipeline.name, dataValidation: "-", mappedIn: "-", transformation: "-", dataLoadedIn: "-" }
        );

        const totalSeconds =
          (logEntries.dataValidationSeconds || 0) +
          (logEntries.mappedInSeconds || 0) +
          (logEntries.transformationSeconds || 0) +
          (logEntries.dataLoadedInSeconds || 0);

        logEntries.totalTime = formatTime(totalSeconds);
        return logEntries;
      });

      setTasks(formattedData);
    }
  }, [pipelinesWithLogs]);

  return (
    <div>
      <SubTitle title="Pipeline Status" showDropdown={false} />
      {tasks && tasks.length > 0 ?
        (
          <div className="min-h-20 h-64 overflow-y-auto">
            <table className="task-table">
              <thead>
                <tr>
                  <th>Pipeline Name</th>
                  <th>Data Validation</th>
                  <th>Mapped In</th>
                  <th>Transformation</th>
                  <th>Data Loaded In</th>
                  <th>Total Time</th>
                </tr>
              </thead>
              <tbody className="bg-white">
                {tasks.map((row, index) => (
                  <tr key={index}>
                    <td className="font-normal bg-white">{row.taskName}</td>
                    <td className="font-normal bg-white">{row.dataValidation}</td>
                    <td className="font-normal bg-white">{row.mappedIn}</td>
                    <td className="font-normal bg-white">{row.transformation}</td>
                    <td className="font-normal bg-white">{row.dataLoadedIn}</td>
                    <td className="font-normal bg-white">{row.totalTime}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-sm font-medium flex items-center justify-center h-64">
            No data available.
          </div>
        )}
    </div>
  );
};

export default TaskStatus;